// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__2u_m3","filled":"IconReviewStar_filled__18gGI","goldFilled":"IconReviewStar_goldFilled__2fJlS","goldEmpty":"IconReviewStar_goldEmpty__1Q7Mz"};